import React from "react";

const LeftPanel = () => {
  const skills = {
    "Development": ["React.js", "Node.js", "Next.js", "HTML/CSS/JS", "TypeScript", "Express.js"],
    "Web3 / Blockchain": ["Solidity", "Ethereum/Polygon", "dApps", "NFTs", "Tokens", "Web3.js/Ethers.js"],
    "Marketing / Growth": ["Social Media", "SEO/SEM", "Email Marketing", "Analytics", "Growth Hacking"],
    "Bots / Automation": ["Discord bots", "Telegram bots", "Automation scripts / Python bots"],
    "Full Stack Tools": ["Git/GitHub", "REST APIs / GraphQL", "MongoDB/PostgreSQL", "Firebase/Supabase", "Testing (Jest, Cypress)"]
  };

  return (
    <div
      style={{
        padding: "20px",
        background: "rgba(0,0,0,0.3)", // glassmorphism look
        borderRadius: "15px",
        color: "white",
        maxWidth: "250px",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
    >
      <h3 style={{ color: "#00ffff" }}>Skills</h3>
      {Object.keys(skills).map((category) => (
        <div key={category}>
          <h4 style={{ fontSize: "14px", opacity: 0.8, marginBottom: "5px" }}>{category}</h4>
          <ul style={{ margin: 0, paddingLeft: "15px", fontSize: "13px", opacity: 0.7 }}>
            {skills[category].map((skill) => (
              <li key={skill}>{skill}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default LeftPanel;